import { X } from "lucide-react";

export default function CoffeeModal({ beans, onClose }) {
  if (!beans) return null;

  const {
    beansName, roaster, altitude, varietal, process,
    tastingnotes, personalremarks, beanspicture,
    originCountry, roasterCountry, rating, category,
  } = beans;

  const PLACEHOLDER = "https://via.placeholder.com/400?text=Coffee+Beans";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="bg-card border border-border rounded-lg w-full max-w-lg max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative">
          <img
            src={beanspicture || PLACEHOLDER}
            alt={beansName}
            className="w-full h-56 object-cover rounded-t-lg"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = PLACEHOLDER; }}
          />
          <button
            onClick={onClose}
            className="absolute top-3 right-3 bg-card/80 hover:bg-card rounded-full p-1.5 transition-colors"
          >
            <X size={18} className="text-foreground" />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div>
            <h2 className="text-lg font-medium text-foreground">{beansName}</h2>
            <p className="text-sm text-muted">{roaster}</p>
          </div>

          <div className="flex flex-wrap gap-2">
            {originCountry && originCountry !== "Unknown" && (
              <span className="text-xs px-2 py-1 rounded-full bg-border/60 text-foreground">
                Origin: {originCountry}
              </span>
            )}
            {roasterCountry && roasterCountry !== "Unknown" && (
              <span className="text-xs px-2 py-1 rounded-full bg-border/60 text-foreground">
                Roaster: {roasterCountry}
              </span>
            )}
            {category && (
              <span className="text-xs px-2 py-1 rounded-full bg-border/40 text-muted">
                {category}
              </span>
            )}
            {rating && (
              <span className="text-xs px-2 py-1 rounded-full bg-border/60 text-foreground font-medium">
                {rating}/10
              </span>
            )}
          </div>

          <div className="grid grid-cols-2 gap-3 text-sm">
            {varietal && (
              <div>
                <p className="text-muted text-xs uppercase tracking-wide mb-0.5">Varietal</p>
                <p className="text-foreground">{varietal}</p>
              </div>
            )}
            {process && (
              <div>
                <p className="text-muted text-xs uppercase tracking-wide mb-0.5">Process</p>
                <p className="text-foreground">{process}</p>
              </div>
            )}
            {altitude && (
              <div>
                <p className="text-muted text-xs uppercase tracking-wide mb-0.5">Altitude</p>
                <p className="text-foreground">{altitude}m</p>
              </div>
            )}
          </div>

          {tastingnotes && (
            <div>
              <p className="text-muted text-xs uppercase tracking-wide mb-1">Tasting Notes</p>
              <p className="text-foreground text-sm">{tastingnotes}</p>
            </div>
          )}

          {personalremarks && (
            <div className="border-t border-border pt-3">
              <p className="text-muted text-xs uppercase tracking-wide mb-1">Remarks</p>
              <p className="text-muted text-sm italic">{personalremarks}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
